export const getPageFromUrl = (url: string): number | undefined => {
	const urlObj = new URL(url)
	const page = urlObj.searchParams.get('page')
	return page ? +page : undefined
}